import { render } from "./QuestionRadioItem.vue?vue&type=template&id=42fcef8e&scoped=true"
import script from "./QuestionRadioItem.vue?vue&type=script&lang=js"
export * from "./QuestionRadioItem.vue?vue&type=script&lang=js"

import "./QuestionRadioItem.vue?vue&type=style&index=0&id=42fcef8e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-42fcef8e"

export default script